
import axios from 'axios';
import config from '../config';

const createClient = (state, options = {}) => {
    const apiClient = axios.create({
        baseURL: config.contentApiBaseUrl,
        timeout: 2 * 60 * 1000,
        headers: {
            Authorization: `Bearer ${state.authentication.authenticationToken || ''}`
        },
        ...options,
    });
    apiClient.interceptors.response.use(response => (response), error => {
        if (error.response && error.response.status >= 400) {
            if (typeof window !== 'undefined' && window.$cookies) {
                window.$cookies.remove("authentication_token");
                window.$cookies.remove("userData");
            }

            if (typeof error.response.data === 'object') {
                return Promise.reject(error.response.data);
            }
            if (typeof error.response.data === 'string') {
                return Promise.reject(new Error(error.response.data));
            }
        }
        // Do something with response error
        return Promise.reject(error);
    });

    return apiClient;
};

export default createClient;



// WEBPACK FOOTER //
// ./src/helpers/api-client.js